const createSystem = {
  createSystem: {
    selectSystem:
      'Sélectionnez un système pour lequel vous souhaitez une revue de design:',
    residential: 'Résidentiel',
    commercial: 'Commercial',
    selectfromList:
      'Sélectionnez à partir de la liste de systèmes déjà créés sur Enlighten',
    enterSystemName: 'Veuillez saisir le nom du système',
    siteSelectionErrorMsg1: 'Vous avez sélectionné un système ',
    siteSelectionErrorMsg2: '. Merci de sélectionner un système ',
    siteSelectionErrorMsg3: ' pour continuer.',
    commercialErrorMsg: 'commercial',
    residentialErrorMsg: 'résidentiel',
    createNewSystem: 'Créer un nouveau système',
    systemName: 'Nom du système',
    type: 'Type',
    thirdParty: 'Propriété de tiers (« ex » : AAE ou location)',
    siteInformation: 'Information du site',
    owner: 'Propriétaire',
    collapse: 'Réduire',
    expand: 'Développer',
    customerName: 'Nom du client',
    address: 'Adresse',
    zipCode: 'Code postal',
    noOfMicroinverters: 'Nombre de micro-onduleurs',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    email: 'Email',
    phone: 'Téléphone',
    enlightenVersion: 'Version d’Enlighten',
    myEnlighten: 'MyEnlighten',
    monitoring:
      'Le propriétaire recevra MyEnlighten pour le contrôle des performances du système.',
    location: 'Localisation',
    streetAddress1: 'Adresse 1',
    streetAddress2: 'Adresse 2',
    zipCodePostal: 'Code postal',
    country: 'Pays',
    state: 'État/Province',
    city: 'Ville',
    deviceDetails: "Détails de l'appareil",
    enphaseGuideLine:
      'Enphase fournit des conseils et des ressources pour aider les installateurs à concevoir un système dans le respect des paramètres appropriés. L’installateur et l’électricien qualifié sont responsables de la conception et de la mise en œuvre finales.',
    confirm: 'Je confirme ce qui suit',
    authorized:
      'Je suis autorisé à m’inscrire à Enlighten au nom du propriétaire ou de l’hôte du système, qui m’a donné la permission de soumettre ces informations à Enphase en son nom.',
    readUnderstand: `J’ai lu et compris la`,
    privacyPolicy: 'Politique de confidentialité',
    and: 'et les',
    terms: 'Conditions de service',
    policy: 'les « Politiques » d’Enphase',
    acknowledge:
      'Le propriétaire ou l’hôte du système a reconnu avoir lu et compris les politiques.',
    informedSystemOwner:
      'J’ai informé le propriétaire ou l’hôte du système que mon entreprise pourra contrôler sa consommation d’énergie et les heures d’utilisation, et qu’il peut révoquer cette autorisation à tout moment',
    proceedCreateSystem: 'Continuer sans créer ni lier un nouveau système',
    cancel: 'ANNULER',
    agreedForTerms1: "J'ai lu et accepté tous les ",
    agreedForTerms2: " de l'Enphase Design Review Services",
    termsAndCondition: ' termes et conditions',
    noOption: 'Geen opties',
    france: 'France',
    switzerland: 'Suisse',
  },
};

export default createSystem;
